import { Component, ElementRef, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService, AuthUser } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { Observable, Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  router = inject(Router);
  private elementRef = inject(ElementRef);

  user$: Observable<AuthUser | null>;
  isMobileMenuOpen = false;
  isAdminDropdownOpen = false;

  private subs = new Subscription();

  constructor() {
    this.user$ = this.authService.user$;
  }

  ngOnInit(): void {
    // Cerrar automáticamente el menú hamburguesa al cambiar de ruta
    this.subs.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.closeMobileMenu();
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    if (!target) return;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.isMobileMenuOpen = false;
      this.isAdminDropdownOpen = false;
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 992 && this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }
  }

  toggleMobileMenu(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (!this.isMobileMenuOpen) {
      this.isAdminDropdownOpen = false;
    }
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.isAdminDropdownOpen = false;
  }

  toggleAdminDropdown(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isAdminDropdownOpen = !this.isAdminDropdownOpen;
  }

  isServicioSocialActive(): boolean {
    const url = this.router.url;
    return (
      url.startsWith('/admin/talks') ||
      url.startsWith('/admin/campaigns') ||
      url.startsWith('/admin/adoptions') ||
      url.startsWith('/admin/identifications')
    );
  }

  @HostListener('keydown.escape')
  onEscape(): void {
    this.isAdminDropdownOpen = false;
    this.isMobileMenuOpen = false;
  }

  logout(): void {
    this.closeMobileMenu();
    this.authService
      .logout()
      .then(() => this.router.navigateByUrl('/auth/login'))
      .catch((error) => {
        console.error('Logout error', error);
      });
  }

  isPublicFormPage(): boolean {
    return this.router.url.startsWith('/formularios/');
  }
}
